import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { LocalAuthoritySection } from '../components/LocalAuthoritySection';
import { BlogSection } from '../components/BlogSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { useSeo } from '../components/useSeo';
export function HomePage() {
  useSeo({
    title: 'Webdesign voor Financiële Dienstverleners in Alkmaar & Amsterdam | Noord',
    description: 'Vaste prijs vooraf, lokaal aanspreekpunt en een structurele klantenstroom uit Google. Wij bouwen websites voor accountants en financieel adviseurs (1-5 medewerkers).',
    canonical: 'https://noorddigital.nl/',
    jsonLd: [{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Noord Digital',
      url: 'https://noorddigital.nl/'
    }, {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Noord Digital',
      description: 'Webdesign en SEO voor financiële dienstverleners in Alkmaar en Amsterdam.',
      url: 'https://noorddigital.nl/',
      telephone: '+31616265214',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Schuit 8a',
        addressLocality: 'Oudkarspel',
        postalCode: '1724 BD',
        addressCountry: 'NL'
      }
    }]
  });
  return <main data-id="element-1097">
      <HeroSection data-id="element-1098" />
      <ProblemSection data-id="element-1099" />
      <ServicesSection data-id="element-1100" />
      <ProcessSection data-id="element-1101" />
      <LocalAuthoritySection data-id="element-1102" />
      <BlogSection data-id="element-1103" />
      <FinalCtaSection data-id="element-1104" />
    </main>;
}